import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-thanks-for-upgrade',
  templateUrl: './thanks-for-upgrade.component.html',
  styleUrls: ['./thanks-for-upgrade.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class ThanksForUpgradeComponent implements OnInit {

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() { }

  async dismiss() {
    this.modalCtrl.dismiss();
  }

}
